import request from './service/index'

export function getProtectionLevel_Api() {//查询词条
  return request({
    url: 'CMS/heritage/protection_level',
    method: 'get',
  });
}
export function createProtectionLevel_Api(data) {//创建词条
  return request({
    url: 'CMS/heritage/protection_level',
    method: 'post',
    data: data
  });
}

export function updateProtectionLevel_Api(data) {//更新词条
  return request({
    url: 'CMS/heritage/protection_level',
    method: 'put',
    data: data
  });
}

export function deleteProtectionLevel_Api(data) {//删除词条
  return request({
    url: 'CMS/heritage/protection_level',
    method: 'delete',
    data: data
  });
}


export function getSpatialLevel_Api() {//查询词条
  return request({
    url: 'CMS/heritage/spatial_level',
    method: 'get',
  });
}

export function createSpatialLevel_Api(data) {//创建词条
  return request({
    url: 'CMS/heritage/spatial_level',
    method: 'post',
    data: data
  });
}

export function updateSpatialLevel_Api(data) {//更新词条
  return request({
    url: 'CMS/heritage/spatial_level',
    method: 'put',
    data: data
  });
}

export function deleteSpatialLevel_Api(data) {//删除词条
  return request({
    url: 'CMS/heritage/spatial_level',
    method: 'delete',
    data: data
  });
}


export function heritageList_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_list',
    method: 'post',
    data: data
  });
}

export function deleteHeritageList_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_list',
    method: 'delete',
    data: data
  });
}


export function getCityData_Api(id) {//查询词条
  return request({
    url: `CMS/city/city_data?city_id=${id} `,
    method: 'get',
  });
}

export function createCityData_Api(data) {//创建词条
  return request({
    url: 'CMS/city/city_data',
    method: 'post',
    data: data
  });
}

export function updateCityData_Api(data) {//更新词条
  return request({
    url: 'CMS/city/city_data',
    method: 'put',
    data: data
  });
}

export function deleteCityData_Api(data) {//删除词条
  return request({
    url: 'CMS/city/city_data',
    method: 'delete',
    data: data
  });
}

export function heritageDetail_Api(id) {
  return request({
    url: `CMS/heritage/heritage_detail?heritage_id=${id} `,
    method: 'get',
  });
}

export function createHeritageDetail_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_detail',
    method: 'post',
    data: data
  });
}

export function updateHeritageDetail_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_detail',
    method: 'put',
    data: data
  });
}

export function deleteHeritageDetail_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_detail',
    method: 'delete',
    data: data
  });
}
export function heritageCount_Api() {
  return request({
    url: 'CMS/heritage/heritage_count',
    method: 'get',
  });
}

export function getHeritageSrcType() {
  return request({
    url: 'CMS/heritage/heritage_src_type',
    method: 'get',
  });
}

export function getHeritageSrc() {
  return request({
    url: 'CMS/heritage/heritage_src',
    method: 'get',
  });
}

export function updateHeritageSrc(data) {
  return request({
    url: 'CMS/heritage/heritage_src',
    method: 'put',
    data: data,
  });

}

export function createHeritageSrc(data) {
  return request({
    url: 'CMS/heritage/heritage_src',
    method: 'post',
    data: data
  });
}

export function deleteHeritageSrc(data) {
  return request({
    url: 'CMS/heritage/heritage_src',
    method: 'delete',
    data: data
  });
}

export function createHeritageModel_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_model',
    method: 'post',
    data: data
  });
}

export function deleteHeritageModel_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_model',
    method: 'delete',
    data: data
  });
}

export function updateHeritageModel_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_model',
    method: 'put',
    data: data
  });
}

export function getHeritageModel_Api(id) {
  return request({
    url: `CMS/heritage/heritage_model?heritage_id=${id}`,
    method: 'get',
  });
}

export function getHeritageModelVoice_Api(id) {
  return request({
    url: `CMS/heritage/heritage_voice?model_id=${id}`,
    method: 'get',
  });
}
export function createHeritageModelVoice_Api(data) {
  return request({
    url: 'CMS/heritage/heritage_voice',
    method: 'post',
    data: data
  });
}





// export function outputheritage_Api(data) {
//   return request({
//     url: 'CMS/heritage/output',
//     method: 'post',
//     data: data
//   });
// }




// WEBPACK FOOTER //
// ./src/apis/heritage.api.js